import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHandler, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError, Observable, observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as cors from 'corslite';
import { IUserData } from '../add-user/cdnuser';

@Injectable()
export class AddUserService {

  private  baseUrl = environment.baseUrl;
  constructor(private http:HttpClient) { }

  getCDNUserSearch(searchStr:string){
    return this.http.get(`${this.baseUrl}/api/users/search?userSearch=${searchStr}`)
              .pipe(
                catchError(this.handleError)
              );
  }
    
  addUser(userData:any){
    return this.http.post(`${this.baseUrl}/api/Login/SignUp`, userData)
            .pipe(
                catchError(this.handleError)
            );
  }

  getCDNUserData(): Observable<IUserData> {
    const URL = `${this.baseUrl}/api/Login/LoadAllUsers`;
    return this.http.get<IUserData>(URL);
  }

  updateStatus(userData:any){
    return this.http.post(`${this.baseUrl}/api/users/updateStatus`, userData)
            .pipe(
                catchError(this.handleError)
            );
  }

  deleteUser(userData:any){
    return this.http.post(`${this.baseUrl}/api/users/deleteUser`, userData)
            .pipe(
                catchError(this.handleError)
            );
  }

  changeProfile(userData:any){
    return this.http.post(`${this.baseUrl}/api/users/changeProfile`, userData)
            .pipe(
                catchError(this.handleError)
            );
  }

  private handleError(error:HttpErrorResponse) {
    if(error.error instanceof ErrorEvent) {
      console.error('An error occured', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error}`
      );
    }
    return throwError(error.error);
  }
}